import authLogger from './auth-logger'

const THROTTLE_MS = 30_000
const DEFAULT_INACTIVE_THRESHOLD_MS = 5 * 60 * 1000
const ACTIVITY_EVENTS = ['click', 'keyup', 'scroll', 'mousemove']

class UserActivity {
  _lastActiveAt = 0
  _lastUpdate = 0
  _handler = null

  start() {
    if (this._handler) {
      return
    }

    this._lastActiveAt = Date.now()
    this._lastUpdate = Date.now()

    this._handler = () => {
      const now = Date.now()
      if (now - this._lastUpdate >= THROTTLE_MS) {
        this._lastActiveAt = now
        this._lastUpdate = now
      }
    }

    ACTIVITY_EVENTS.forEach((event) => {
      document.addEventListener(event, this._handler, { passive: true, capture: true })
    })

    authLogger.debug('user activity tracking started')
  }

  stop() {
    if (!this._handler) {
      return
    }

    ACTIVITY_EVENTS.forEach((event) => {
      document.removeEventListener(event, this._handler, { capture: true })
    })

    this._handler = null
    this._lastActiveAt = 0
    this._lastUpdate = 0
    authLogger.debug('user activity tracking stopped')
  }

  /**
   * @param {number} [thresholdMs] - Inactivity threshold in ms (default 5 minutes)
   * @returns {boolean}
   */
  isRecentlyActive(thresholdMs = DEFAULT_INACTIVE_THRESHOLD_MS) {
    return (Date.now() - this._lastActiveAt) < thresholdMs
  }
}

export const userActivity = new UserActivity()
